const fetchFileType = async (url: string) => {
  const response = await fetch(url, { method: 'HEAD' })
  return response.headers.get('Content-Type')
}

/**
 * Checks the header of the url's Content-Type to see if it's an image. It returns
 * `true` by default because the image renderers have a an `onError` handler that
 * will then try render as a document. If any of this changes, consider changing
 * this function.
 */
export const isFileImage = async (url: string) => {
  try {
    const type = await fetchFileType(url)
    return type?.startsWith('image') ?? true
  } catch {
    return true
  }
}
